var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptionSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0323 4.18359C17.2511 4.18359 18.2476 5.13501 18.3198 6.33566L18.324 6.47526V13.5628C18.324 14.7816 17.3726 15.7782 16.1719 15.8503L16.0323 15.8545H3.96745C2.74867 15.8545 1.75211 14.9031 1.67996 13.7024L1.67578 13.5628V6.47526C1.67578 5.25648 2.6272 4.25992 3.82785 4.18778L3.96745 4.18359H16.0323ZM17.0733 9.16193H2.92495L2.92578 13.5628C2.92578 14.1022 3.33568 14.5458 3.86094 14.5991L3.96745 14.6045H16.0323C16.5717 14.6045 17.0153 14.1946 17.0686 13.6693L17.074 13.5628L17.0733 9.16193ZM15.2107 12.083C15.5558 12.083 15.8357 12.3628 15.8357 12.708C15.8357 13.0244 15.6005 13.2859 15.2955 13.3273L15.2107 13.333H13.1273C12.7821 13.333 12.5023 13.0532 12.5023 12.708C12.5023 12.3916 12.7375 12.1301 13.0425 12.0887L13.1273 12.083H15.2107ZM16.0323 5.43359H3.96745C3.42811 5.43359 2.9845 5.84349 2.93116 6.36876L2.92578 6.47526L2.92495 7.91193H17.0733L17.074 6.47526C17.074 5.93592 16.6641 5.49232 16.1388 5.43897L16.0323 5.43359Z",
    fill: "#2B391C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionSettingsIcon);
export default __webpack_public_path__ + "static/media/subscription_settings_icon.c2a0370f31495c1c8dc0fe90d18af41e.svg";
export { ForwardRef as ReactComponent };